var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberSix = function SvgIconNumberSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13.332 8.126.001-.002a.5.5 0 1 0-.665-.746l-.003.003-.01.008-.035.032-.13.12a18.513 18.513 0 0 0-1.816 1.996c-.493.633-.993 1.371-1.365 2.15-.37.774-.627 1.618-.602 2.457.004 1.722 1.419 3.107 3.149 3.107 1.733 0 3.149-1.39 3.149-3.116s-1.416-3.115-3.15-3.115a3.2 3.2 0 0 0-1.156.217c.237-.379.498-.744.764-1.084a17.5 17.5 0 0 1 1.832-1.994l.03-.027zm-3.625 6.01c0-1.163.956-2.116 2.149-2.116s2.149.953 2.149 2.115-.956 2.116-2.15 2.116c-1.192 0-2.148-.953-2.148-2.116",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12.25c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10m-1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberSix;